// @flow

import React from "react";
import { localize } from "redux-i18n";

import { ColumnsContainer } from "@components";
import type { Rows } from "@components/columns-container/types";
import type { EmailNotification } from "@modules/service/reducer/email-notifications/types";

type Props = $Exact<{
  data: EmailNotification,
  ...PropsFromLocalize,
}>;

export class EmailNotificationsMainView extends React.Component<Props> {
  get data(): Array<Rows> {
    return [
      {
        columns: [
          {
            data: [
              [
                this.props.t("EMAIL_NOTIFICATION_EMAIL_DISTRIBUTION_NAME"),
                this.props.t(this.props.data.name),
              ],
            ],
          },
          {
            data: [],
          },
          {
            data: [],
          },
        ],
      },
    ];
  }

  render() {
    return <ColumnsContainer rows={this.data} className="mb-2" />;
  }
}

export default localize()(EmailNotificationsMainView);
